const Footer = () => {
  return (
    <footer className="bg-dark text-light mb-0">
      <div className="container text-cente  py-3">
        <small>
          © {new Date().getFullYear()} <strong>Aarnayours</strong>. All Rights Reserved.
        </small>
      </div>
    </footer>
  );
};

export default Footer;
